export * from './lib/appointment-data-access.module';
export * as AppointmentActions from './lib/+state/appointment.actions';
export * as AppointmentSelectors from './lib/+state/appointment.selectors';